var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EventSeriesOption } from './useEvent/useEventTypes';
import { buildUpdateEventPayload } from '../utils/payloadBuilders';
import { getRecurrenceKey } from '../components/RecurrenceDropdown/utils';
import { resolvePendingMove, } from '../utils/spaceOrchestration';
export var useHandleEventUpdate = function (_a) {
    var formData = _a.formData, timezone = _a.timezone, initialEvent = _a.initialEvent, calendarType = _a.calendarType, calendarMailboxAddress = _a.calendarMailboxAddress, performSave = _a.performSave, setRecurringEventToUpdate = _a.setRecurringEventToUpdate, spacesState = _a.spacesState, setPendingSaveWithMove = _a.setPendingSaveWithMove, onError = _a.onError;
    var t = useTranslation('meetingRooms').t;
    var handleEventUpdate = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedEvent, recurrenceValueChanged, resolvedMove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(formData === null || formData === void 0 ? void 0 : formData.eventId)) {
                        onError(new Error(t('update_event.no_event_id_found')));
                        return [2 /*return*/];
                    }
                    updatedEvent = buildUpdateEventPayload({
                        formData: formData,
                        timezone: timezone,
                        calendarType: calendarType,
                        calendarMailboxAddress: calendarMailboxAddress,
                    });
                    recurrenceValueChanged = getRecurrenceKey(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.recurrenceRule) !==
                        getRecurrenceKey(updatedEvent === null || updatedEvent === void 0 ? void 0 : updatedEvent.recurrence);
                    if (!updatedEvent) return [3 /*break*/, 3];
                    resolvedMove = resolvePendingMove(spacesState, initialEvent && 'spaces' in initialEvent
                        ? initialEvent.spaces
                        : undefined, formData.spaces);
                    if (resolvedMove) {
                        if (recurrenceValueChanged) {
                            // A recurrence change PATCHes the whole series while a move is
                            // instance-only — the two can't ride one save.
                            onError(new Error(t('errors.cannot_change_room_and_recurrence')));
                            return [2 /*return*/];
                        }
                        setPendingSaveWithMove({ payload: updatedEvent, move: resolvedMove });
                        return [2 /*return*/];
                    }
                    if (!((initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.seriesId) && !recurrenceValueChanged)) return [3 /*break*/, 1];
                    // Declines run in UpdateRecurringEventModal instead, after the user
                    // confirms a series option. Declining here would mutate the event
                    // even if the user cancels the modal.
                    setRecurringEventToUpdate(updatedEvent);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, performSave(updatedEvent, {
                        seriesOption: recurrenceValueChanged
                            ? EventSeriesOption.ALL_EVENTS
                            : EventSeriesOption.THIS_EVENT,
                        recurrenceChanged: recurrenceValueChanged,
                        analytics: { recurring: false },
                    })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        formData,
        timezone,
        initialEvent,
        calendarType,
        calendarMailboxAddress,
        performSave,
        setRecurringEventToUpdate,
        spacesState,
        setPendingSaveWithMove,
        onError,
        t,
    ]);
    return { handleEventUpdate: handleEventUpdate };
};
